'use strict';

angular.module('TurneroApp').service('domicilioService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Domicilio/:id', { id: '@Id_Domicilio' }, {
        getDomicilio: {
            method: 'GET',
            params: {
                id_Vin: '@id_Vin'
            },
            url: portal.getUrlServer() + 'api/Domicilio/Unidad_Id_Vin/',
            headers: portal.getHeadersServer()//,
            //isArray: true
        },
        getPersonaJuridica: {
            method: 'GET',
            params: {
                CUIT: '@CUIT'
            },
            url: portal.getUrlServer() + 'api/Domicilio/Personas_Juridicas/',
            headers: portal.getHeadersServer(),

        },
    });
}]);



// WEBPACK FOOTER //
// ./app/components/general/domicilio-service.js